import { parseAsArrayOf, parseAsString } from 'nuqs';

const arrayOfStrings = parseAsArrayOf(parseAsString);

export enum IngredientFilterKey {
  EmissionsCategory = 'emissionsCategory',
}
export enum IngredientFilterColumn {
  EmissionsCategory = 'emissionsCategory',
}

export enum IngredientFilterApiKey {
  EmissionsCategory = 'emissions_category',
}

export const ingredientFilters = {
  [IngredientFilterKey.EmissionsCategory]: {
    column: IngredientFilterColumn.EmissionsCategory,
    apiKey: IngredientFilterApiKey.EmissionsCategory,
    type: arrayOfStrings,
  },
};

export type IngredientFilterOption = keyof typeof ingredientFilters;

export const ingredientFilterKeys = Object.keys(
  ingredientFilters
) as IngredientFilterOption[];
